const normaliseAppOrigin = (value: string | undefined): string => {
  if (!value) {
    throw new Error('VITE_SAVAF_APP_URL is not configured');
  }

  let url: URL;
  try {
    url = new URL(value);
  } catch {
    throw new Error('VITE_SAVAF_APP_URL must be a valid absolute URL');
  }

  if (
    !['http:', 'https:'].includes(url.protocol) ||
    url.username ||
    url.password ||
    url.pathname !== '/' ||
    url.search ||
    url.hash
  ) {
    throw new Error('VITE_SAVAF_APP_URL must be an HTTP(S) origin without credentials, a path, query, or fragment');
  }

  return url.origin;
};

export const savafAppOrigin = normaliseAppOrigin(import.meta.env.VITE_SAVAF_APP_URL);

export const savafAppUrl = (path: `/${string}`): string => {
  if (path.startsWith('//')) {
    throw new Error('SavaF app paths must be root-relative');
  }

  const url = new URL(path, `${savafAppOrigin}/`);
  if (url.origin !== savafAppOrigin) {
    throw new Error('SavaF app paths must stay on the configured app origin');
  }

  return url.toString();
};
